import { takeLatest, put, call } from "redux-saga/effects";
import ACTIONS from "./BlocklistActionTypes";
import { UnautherizedResponse } from "../GetUser/GetUserActions";
import { axiosPost, axiosDelete } from "../../Utils/axios";
import {
  deleteBlockListResponse,
  getBlocklistListResponse,
  postBlockListResponse,
} from "./BlocklistActions";

export function* onGetBlocklistListHelperSaga({ payload }) {
  try {
    let response = yield call(() =>
      axiosPost("blocklist/index", payload).then((res) => res?.data)
    );
    yield put(getBlocklistListResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostBlocklistHelperSaga({ payload }) {
  try {
    let response = yield call(() =>
      axiosPost("blocklist/new", payload).then((res) => res?.data)
    );
    yield put(postBlockListResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onDeleteBlocklistHelperSaga({ payload }) {
  try {
    let response = yield call(() =>
      axiosDelete(`blocklist/${payload?._id}`).then((res) => res?.data)
    );
    yield put(deleteBlockListResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* BlockListWatcherSaga() {
  yield takeLatest(ACTIONS.GET_BLOCKLIST_REQUEST, onGetBlocklistListHelperSaga);
  yield takeLatest(ACTIONS.POST_BLOCKLIST_REQUEST, onPostBlocklistHelperSaga);
  yield takeLatest(
    ACTIONS.DELETE_BLOCKLIST_REQUEST,
    onDeleteBlocklistHelperSaga
  );
}
